import env from './environment'

// const apiIp = '52.51.170.157'
const apiIp = 'dev-api-cluster.system.touchetv.com'
const apiIpProd = 'api-cluster.system.touchetv.com'

enum ApiType {
  MAIN = 'mainApi',
  USER = 'userApi',
  MARKET_PLACE_URL = 'MARKET_PLACE_URL',
  PLUGIN_URL = 'PLUGIN_URL'
}

interface Settings {
  [ApiType.MAIN]: string
  [ApiType.USER]: string
  [ApiType.MARKET_PLACE_URL]?: string
  [ApiType.PLUGIN_URL]?: string
  backofficeSite:string
  // videoProcessingApi: string;
  // statsApi: string;
  // actionHistoryApi: string;
  // spriteUrl: string;
}

interface SettingsList {
  localhost: Settings
  development: Settings
  staging: Settings
  production: Settings
}

const settingsList: SettingsList = {
  localhost: {
    [ApiType.MAIN]: 'http://localhost:8082/api/v1',
    [ApiType.USER]: 'http://localhost:8081/api/v1',
    [ApiType.PLUGIN_URL]: 'http://localhost:8080/plugin.js',
    backofficeSite: 'http://localhost:3000'
  },
  // development: {
  //   [ApiType.MAIN]: `https://${apiIp}/marketplace/api/v1`,
  //   [ApiType.USER]: `https://${apiIp}/marketplace-user/api/v1`
  // },
  development: {
    [ApiType.MAIN]: `https://${apiIp}/marketplace/api/v1`,
    [ApiType.USER]: `https://${apiIp}/marketplace-user/api/v1`,
    [ApiType.MARKET_PLACE_URL]: 'https://marketplace-dev.system.touchetv.com',
    [ApiType.PLUGIN_URL]: 'https://touche-player-dev.system.touchetv.com/plugin.js',
    backofficeSite: 'https://touche-studio-dev.system.touchetv.com'
  },
  staging: {
    [ApiType.MAIN]: `https://${apiIp}/marketplace/api/v1`,
    [ApiType.USER]: `https://${apiIp}/marketplace-user/api/v1`,
    [ApiType.MARKET_PLACE_URL]: 'https://marketplace-dev.system.touchetv.com',
    [ApiType.PLUGIN_URL]: 'https://touche-player-dev.system.touchetv.com/plugin.js',
    backofficeSite: 'https://touche-studio-dev.system.touchetv.com'
  },
  production: {
    [ApiType.MAIN]: `https://${apiIpProd}/marketplace/api/v1`,
    [ApiType.USER]: `https://${apiIpProd}/marketplace-user/api/v1`,
    [ApiType.MARKET_PLACE_URL]: 'https://marketplace-product.system.touchetv.com',
    [ApiType.PLUGIN_URL]: 'https://touche-player-product.system.touchetv.com/plugin.js',
    backofficeSite: 'https://touche-studio-product.system.touchetv.com'
  }
}

const settings: Settings = settingsList[env]

export { settings, ApiType }
